import { ReactNode } from 'react';
import { Box, Flex, Text, chakra } from '@chakra-ui/react';

interface CheckboxProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  label: ReactNode;
  error?: string;
  required?: boolean;
}

export const Checkbox = ({
  checked,
  onChange,
  label,
  error,
  required = false,
}: CheckboxProps) => {
  return (
    <Box w="full">
      <chakra.label
        display="flex"
        alignItems="center"
        cursor="pointer"
        py="2"
        gap="3"
      >
        <chakra.input
          type="checkbox"
          checked={checked}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => onChange(e.target.checked)}
          position="absolute"
          opacity={0}
          w="0"
          h="0"
          required={required}
        />
        <Flex
          w="5"
          h="5"
          minW="5"
          flexShrink={0}
          borderWidth="2px"
          borderStyle="solid"
          borderRadius="4px"
          alignItems="center"
          justifyContent="center"
          transition="all 0.2s"
          bg={checked ? 'volyx.primary' : 'white'}
          borderColor={checked ? 'volyx.primary' : 'volyx.mediumGray'}
        >
          {checked && (
            <Text as="span" color="white" fontSize="sm" fontWeight="bold" lineHeight="none">
              ✓
            </Text>
          )}
        </Flex>
        <Text as="span" flex="1" fontSize="sm" fontFamily="body" color="volyx.text" lineHeight="5">
          {label}
        </Text>
      </chakra.label>
      {error && (
        <Text as="span" display="block" mt="1" ml="8" fontSize="xs" color="volyx.error" fontFamily="body">
          {error}
        </Text>
      )}
    </Box>
  );
};
